import sharedConfig from "./config.js";
import { loginSession } from "./LoginSession.jsx";
/*
 * Central config for all apps.

 * Justification: 
 *    Too much clutter for sharedConfig + this is iterable and can contain jsx based descriptions
 *    App access keys are used because we already need to maintain them anyway.
 */
const apps = {
    PMG360_ACCESS: {
        name: "PMG360 Analytics",
        overviewPage: "https://www.pmgintelligence.com/pmg-360/",
        description: (
            <>
                PMG 360 Analytics is fueled by nearly 15 years of our proprietary aggregated quantitative and
                qualitative Canadian financial consumer data and behavioural analysis – including impacts of the
                COVID-19 pandemic.
                <br />
                <br />
                Integrated with census data and your client’s data, it is analysed using machine learning and
                behavioural analysis so PMG can predict future behaviours and unique client needs. All of this is then
                organized for you in advanced dashboards and metrics, facilitating timely and proactive engagement that
                increases loyalty and drives sales.
            </>
        ),
        inquiryPage: sharedConfig.centralFrontendURL + "app-inquiry/pmg360",
        getAppLandingPage: (userInfo = loginSession.userInfo) =>
            sharedConfig.pmg360FrontendURL +
            (userInfo?.superuser ? "superuser/credit-union/create" : "credit-union/input"),
    },

    MARKETMINE_ACCESS: {
        name: "MarketMine",
        getAppLandingPage: (userInfo = loginSession.userInfo) =>
            sharedConfig.marketmineFrontendURL +
            (userInfo?.superuser ? "admin/research-topics" : "users/research-assistant"),
    },

    GROWTH_STUDY_ACCESS: {
        name: "Growth Study",
        getAppLandingPage: (userInfo = loginSession.userInfo) =>
            sharedConfig.growthStudyFrontendURL + (userInfo?.superuser ? "admin/overview" : "users/overview"),
    },

    FHC_ACCESS: {
        name: "Financial Health Score",
        getAppLandingPage: (userInfo = loginSession.userInfo) =>
            sharedConfig.fhcFrontendURL +
            (userInfo?.superuser
                ? "admin/configuration"
                : userInfo?.permissions?.includes("FHC_MANAGE_SURVEYS")
                  ? "questions" // elevated users should see collectors on this page by default
                  : userInfo?.permissions?.includes("FHC_MANAGE_PROFILE")
                    ? "profile" // profile managers should see their profile page by default
                    : userInfo?.permissions?.includes("FHC_VIEW_SURVEY_RESULTS")
                      ? "responses" // regular users can't see collectors so show responses
                      : ""), // it doesn't seem worth it to redirect to a fallback page because the FHC link in the nav drawer is disabled if the user has FHC_ACCESS but no other permissions
    },
};

export default apps;
